import { get } from '../../utils/networking'

export const GET_HEADER = "GET_HEADER"
export const GET_HEADER_SUCCESS = "GET_HEADER_SUCCESS"
export const GET_HEADER_FAIL = "GET_HEADER_FAIL"

export const requestHeader = () => {
    return {
        type: GET_HEADER
    }

}

export const requestHeaderSuccess = (result) => {
    return {
        type: GET_HEADER_SUCCESS,
        payload: result
    }

}

export const requestHeaderFail = () => {
    return {
        type: GET_HEADER_FAIL
    }
}

export const getHeader = () => {
    return dispatch => {
        dispatch(requestHeader())
        get('web/navigation', "", result => {
            dispatch(requestHeaderSuccess(result))
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/header/action.js